// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2TsS9","colMin":"styles_colMin__3iCqp","colCheckbox":"styles_colCheckbox__28gZq"};